import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _createClass from 'babel-runtime/helpers/createClass';
import _inherits from 'babel-runtime/helpers/inherits';

var _templateObject = _taggedTemplateLiteral(['\n    query collectionQuery {\n\t\t\t\n\t\t\t\tcollectionByHandle(handle: "', '") {\n\t\t\t\t\tid\n\t\t\t\t\ttitle\n\t\t\t\t\tproducts(first: 50) {\n\t\t\t\t\t\tedges {\n\t\t\t\t\t\t\tnode {\n\t\t\t\t\t\t\t\tid\n\t\t\t\t\t\t\t\ttitle\n\t\t\t\t\t\t\t\thandle\n\t\t\t\t\t\t\t\tonlineStoreUrl\n\t\t\t\t\t\t\t\ttags\n\t\t\t\t\t\t\t\tpriceRange {\n\t\t\t\t\t\t\t\t\tminVariantPrice {\n\t\t\t\t\t\t\t\t\t\tcurrencyCode\n\t\t\t\t\t\t\t\t\t\tamount\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\timages(first: 2) {\n\t\t\t\t\t\t\t\t\tedges {\n\t\t\t\t\t\t\t\t\t\tnode {\n\t\t\t\t\t\t\t\t\t\t\taltText\n\t\t\t\t\t\t\t\t\t\t\tthumbnailImg: transformedSrc(maxWidth: 100, maxHeight: 120, crop: CENTER)\n\t\t\t\t\t\t\t\t\t\t\tproductImg: transformedSrc(maxWidth: 800, maxHeight: 960, crop: CENTER)\n\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t\n\t\t\t\t}\n\t\t\t}\n\t\t}'], ['\n    query collectionQuery {\n\t\t\t\n\t\t\t\tcollectionByHandle(handle: "', '") {\n\t\t\t\t\tid\n\t\t\t\t\ttitle\n\t\t\t\t\tproducts(first: 50) {\n\t\t\t\t\t\tedges {\n\t\t\t\t\t\t\tnode {\n\t\t\t\t\t\t\t\tid\n\t\t\t\t\t\t\t\ttitle\n\t\t\t\t\t\t\t\thandle\n\t\t\t\t\t\t\t\tonlineStoreUrl\n\t\t\t\t\t\t\t\ttags\n\t\t\t\t\t\t\t\tpriceRange {\n\t\t\t\t\t\t\t\t\tminVariantPrice {\n\t\t\t\t\t\t\t\t\t\tcurrencyCode\n\t\t\t\t\t\t\t\t\t\tamount\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\timages(first: 2) {\n\t\t\t\t\t\t\t\t\tedges {\n\t\t\t\t\t\t\t\t\t\tnode {\n\t\t\t\t\t\t\t\t\t\t\taltText\n\t\t\t\t\t\t\t\t\t\t\tthumbnailImg: transformedSrc(maxWidth: 100, maxHeight: 120, crop: CENTER)\n\t\t\t\t\t\t\t\t\t\t\tproductImg: transformedSrc(maxWidth: 800, maxHeight: 960, crop: CENTER)\n\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t\n\t\t\t\t}\n\t\t\t}\n\t\t}']);

import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import './collections.css';
import Collection from './collection.js';
import { Query } from 'react-apollo';
import { ApolloProvider } from 'react-apollo';
import gql from 'graphql-tag';

var _ref2 = React.createElement(
	'div',
	{ className: 'loading' },
	'Loading...',
	React.createElement(
		'div',
		{ className: 'loader' },
		React.createElement('span', { className: 'inner1' }),
		React.createElement('span', { className: 'inner2' }),
		React.createElement('span', { className: 'inner3' })
	)
);

var SingleCollection = function (_Component) {
	_inherits(SingleCollection, _Component);

	_createClass(SingleCollection, [{
		key: 'getCollection',
		value: function getCollection(handle) {
			return gql(_templateObject, handle);
		}
	}]);

	function SingleCollection() {
		_classCallCheck(this, SingleCollection);

		var _this = _possibleConstructorReturn(this, (SingleCollection.__proto__ || Object.getPrototypeOf(SingleCollection)).call(this));

		_this.state = {
			collection: {},
			display_num: 50,
			filter_tag: null,
			current_page: 1
		};
		_this.getCollection = _this.getCollection.bind(_this);
		_this.queryCompleted = _this.queryCompleted.bind(_this);

		return _this;
	}

	_createClass(SingleCollection, [{
		key: 'queryCompleted',
		value: function queryCompleted(data) {
			console.log('query completed', data.collectionByHandle);

			this.setState({ collection: data.collectionByHandle });
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			return React.createElement(
				'div',
				null,
				React.createElement(
					Query,
					{
						query: this.getCollection(this.props.match.params.handle),
						onCompleted: this.queryCompleted
					},
					function (_ref) {
						var loading = _ref.loading,
						    error = _ref.error,
						    data = _ref.data;

						if (!loading) {
							console.log('in quer', data, error, loading);
							var _state = _this2.state,
							    current_page = _state.current_page,
							    display_num = _state.display_num,
							    collection = _state.collection;

							return React.createElement(
								'div',
								null,
								React.createElement(Collection, {
									collection: collection,
									display_num: display_num,
									current_page: current_page
								})
							);
						} else {
							return _ref2;
						}
					}
				)
			);
		}
	}]);

	return SingleCollection;
}(Component);

export default SingleCollection;